// Converts Claude API error responses into user-friendly Hebrew messages
export function getClaudeUserErrorMessage(error) {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        return "המפתח שסיפקת אינו תקף או חסר. אנא הזן מפתח API תקף.";
      case 403:
        return "אין לך הרשאות להשתמש ב-API הזה. ודא שהמפתח תקין.";
      case 429:
        return "חרגת ממגבלת השימוש במערכת. נסה שוב מאוחר יותר.";
      case 500:
        return "אירעה שגיאה בשרת של Claude. נסה שוב בעוד כמה רגעים.";
      default:
        return `שגיאה (${error.response.status}): נסה שוב או פנה לתמיכה.`;
    }
  } else if (error.request) {
    return "לא ניתן להתחבר לשרת. בדוק את חיבור האינטרנט שלך.";
  } else {
    return `שגיאה כללית: ${error.message}`;
  }
}
